<template>
  <a-modal
    :title="title"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :centered="true"
    :mask-closable="false"
    :width="466"
    wrap-class-name="set-account-modal"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <p class="prompt">
      {{ promptText }}
    </p>
    <a-form
      ref="form"
      :form="form"
    >
      <a-form-item label="邮箱：">
        <a-input
          v-decorator="['email', {
            rules: [{
              required: true, message: '请输入'
            }, { validator: checkEmail }],
            initialValue: email
          }]"
          placeholder="请输入邮箱"
          @change="handleInput($event, 'email',)"
        />
      </a-form-item>
      <a-form-item label="密码：">
        <a-input
          v-decorator="['password', {
            rules: [{
              required: true, message: '请输入'
            }],
            initialValue: password
          }]"
          type="password"
          placeholder="请输入密码"
          @change="handleInput($event, 'password',)"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      form: this.$form.createForm(this),
      confirmLoading: false,
      email: '',
      password: ''
    }
  },

  computed: {
    title () {
      return this.type === 'add' ? '绑定小满主帐号' : '修改小满主帐号'
    },
    promptText () {
      return this.type === 'add' ? '输入小满主帐号信息，完成绑定。' : '输入新的小满主帐号信息，完成修改。'
    }
  },

  methods: {
    ...mapActions('config/xiaoman/baseConfig', ['setXiaomanAccount']),
    handleInput (e, name) {
      let val = e.target.value
      this[name] = val
    },
    checkEmail (rule, value, callback) {
      if (value && !/^[A-Za-z\d0-9]+([-_.][A-Za-z\d0-9]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,64}$/.test(value)) {
        rule.message = '邮箱不是有效的邮箱格式'
        callback(rule.message)
      }
      callback()
    },
    hide () {
      this.email = ''
      this.password = ''
      this.form.resetFields()
      this.$emit('update:visible', false)
    },
    handleOk () {
      if (this.confirmLoading) return
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.confirmLoading = true
          let chain = await this.setXiaomanAccount({
            account: this.email,
            password: this.password
          })
          chain
            .onNetSuccess(raw => {
              this.confirmLoading = false
            })
            .onSuccess(res => {
              this.$emit('setAccount', this.email)
              this.hide()
            })
        }
      })
    },
    handleCancel () {
      this.hide()
    }
  }
}
</script>
<style scoped lang="scss">
.prompt {
  height:40px;
  line-height: 40px;
  margin-bottom: 32px;
  padding: 0 24px;
  background:#E8F4FF;
}
::v-deep .ant-form-item-label {
  float: left;
  width: 106px;
  padding-right: 16px;
  label {
    color: #666;
  }
}
::v-deep .ant-form-item-control-wrapper {
  padding-left: 106px;
}
</style>
<style lang="scss">
.set-account-modal {
  .ant-modal-body {
    padding: 0 0 16px;
  }
}
</style>
